import axios from 'axios';

class ApiService {
    constructor() {
        this.axios = axios.create({
            baseURL: import.meta.env.VITE_API_URL,
            headers: {
                'Content-Type': 'application/json'
            }
        });

        // Interceptor per aggiungere il token
        this.axios.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem('jwt_token');
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        // Interceptor per gestire le risposte
        this.axios.interceptors.response.use(
            (response) => {
                return response.data;
            },
            (error) => {
                if (error.response?.status === 401) {
                    localStorage.removeItem('jwt_token');
                    window.location.href = '/login';
                }
                return Promise.reject(error);
            }
        );
    }

    // Metodi di utilità per le chiamate HTTP
    async get(url, params = {}) {
        try {
            return await this.axios.get(url, { params });
        } catch (error) {
            this.handleError(error);
            throw error;
        }
    }

    async post(url, data = {}) {
        try {
            return await this.axios.post(url, data);
        } catch (error) {
            this.handleError(error);
            throw error;
        }
    }

    async put(url, data = {}) {
        try {
            return await this.axios.put(url, data);
        } catch (error) {
            this.handleError(error);
            throw error;
        }
    }

    async delete(url) {
        try {
            return await this.axios.delete(url);
        } catch (error) {
            this.handleError(error);
            throw error;
        }
    }

    handleError(error) {
        console.error('API Error:', error);
        // Qui puoi implementare una gestione centralizzata degli errori
    }
}

export const apiService = new ApiService(); 